// extracted by mini-css-extract-plugin
export default {"buttonLinkSecondary":"PlasmicButtonLinkSecondary_buttonLinkSecondary__6TAO+","slotTargetText":"PlasmicButtonLinkSecondary_slotTargetText__ryZ0W"};